import type { FC, PropsWithChildren } from "react";

/**
 * Section chrome, shared with `SearchModalListBoxSection` so the loading
 * skeleton groups its placeholder rows exactly like the loaded results group
 * theirs — including the space a group keeps around itself:
 *
 * - from whatever precedes it, be that another group or the all-results row;
 * - none when it opens the list, which the list's own padding already spaces;
 * - a little when it opens the list with a header, which wants clearance from
 *   the search field's edge above it.
 *
 * Reading its own position off the DOM keeps the rule here, rather than in each
 * of the two places that compose a list out of these.
 */
export const searchModalSectionClassName =
  "flex min-w-0 flex-col gap-px mt-3.5 first:mt-0 first:data-[has-title]:mt-1";
export const searchModalSectionHeaderClassName =
  "mb-[3px] text-xs leading-4 font-medium text-muted-foreground";

export interface SearchModalSectionProps extends PropsWithChildren {
  title?: string;
}

/** The plain-DOM twin of `SearchModalListBoxSection`, for the skeleton. */
export const SearchModalSection: FC<SearchModalSectionProps> = (props) => {
  const { title, children } = props;

  return (
    <div
      className={searchModalSectionClassName}
      // Marks the header for the spacing above, rather than the class selecting
      // on an element the two twins would both have to keep rendering.
      data-has-title={title ? "" : undefined}
    >
      {title ? (
        <h2 className={searchModalSectionHeaderClassName}>{title}</h2>
      ) : null}
      {children}
    </div>
  );
};
